<template>
  <div class="absolute top-[15%] left-[10%]">
    <div class="flex max-h-[70vh] max-w-[90vw] overflow-x-scroll scroll-hid">
      <img
        src="img/anomala/anomala1.png"
        class="w-auto max-h-[70vh]"
        loading="lazy"
      />
      <img src="img/shots1.png" class="w-auto max-h-[70vh]" loading="lazy" />
      <img src="img/shots2.png" class="w-auto max-h-[70vh]" loading="lazy" />
      <RandomText
        class="min-w-[40vw] text-center content-center random-text px-[10vw]"
      >
        Learn more <span class="underline cursor-pointer">about</span>
        <span @click="studioClick"> me</span>, or explore a selection of my
        <span class="underline cursor-pointer">recent</span>
        <span @click="projectClick"> projects</span>.
      </RandomText>
    </div>
  </div>
</template>

<script>
import RandomText from "@/components/RandomText.vue";

export default {
  components: {
    RandomText,
  },
  methods: {
    studioClick() {
      this.$emit("studioClicked");
    },
    projectClick() {
      this.$emit("projectsClicked");
    },
  },
  mounted() {
    const textElements = this.$el.querySelectorAll(".random-text");
    textElements.forEach((element) => {
      const randomFontSize = Math.floor(Math.random() * 50 + 6);
      element.style.fontSize = `${randomFontSize}px`;
    });
  },
};
</script>

<style scoped>
.scroll-hid {
  scrollbar-width: none;
}

.scroll-hid::-webkit-scrollbar {
  display: none;
}
</style>
